import React from 'react'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Image from 'components/Common/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextLink from 'LuxKit/TextLink'
import TextButton from 'LuxKit/Button/TextButton'
import { rem } from 'polished'

/**
 * Sitewide banner content for maldives charter takeover.
 * Palm tree overlays are handled by the background component.
 */
function MaldivesCharterPageBanner() {
  return (
    <>
      <CSSBreakpoint max="mobile">
        <Group direction="vertical" verticalAlign="start">
          <BodyText variant="medium" weight="bold">
            Australia's only direct flights to the Maldives
          </BodyText>
          <BodyText variant="small">
            Fly Luxury Escapes' private charter to Malé<span style={{ marginRight: rem(8) }} />
            <TextLink to="/maldives-charter" wrap="no-wrap">View offers</TextLink>
          </BodyText>
        </Group>
      </CSSBreakpoint>

      <CSSBreakpoint min="tablet">
        <Group direction="horizontal" gap={12} verticalAlign="center">
          <Image id="maldives-logo" dpr={2} width={32} height={32} />

          <BodyText variant="medium">
            <b>Australia's only direct flights to the Maldives</b>
            <span style={{ marginRight: rem(8) }} />
            Fly Luxury Escapes' private charter to Malé
          </BodyText>

          <TextButton to="/maldives-charter" size="small" kind="primary">
            View offers
          </TextButton>
        </Group>
      </CSSBreakpoint>
    </>
  )
}

export default MaldivesCharterPageBanner
